import { useState } from "react";
import { useHistory } from "react-router-dom";
import { capture } from "../instrument";

import API from "../api";
import { toast } from "react-hot-toast";

const Auth = () => {
  const history = useHistory();
  const [user, setUser] = useState({ email: "", password: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const signin = async () => {
    if (!user.email || !user.password) {
      toast.error("Veuillez remplir tous les champs");
      return;
    }

    try {
      setIsSubmitting(true);

      const res = await API.post("/user/signin", user);
      if (!res.token) {
        toast.error("Une erreur est survenue");
        return;
      }

      API.setToken(res.token);

      if (res.user?.mustChangePassword) {
        history.push("/change-password");
        return;
      }

      const queryParams = new URLSearchParams(window.location.search);
      const redirectPath = queryParams.get("redirect");
      if (redirectPath) {
        history.push(redirectPath);
        return;
      }

      history.push("/");
    } catch (error) {
      capture(error);
      toast.error(error.message || error.code);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isSubmitting) signin();
  };

  return (
    <div className="min-h-screen bg-slate-50 text-primary-500">
      <div className="mx-auto flex min-h-screen max-w-5xl flex-col justify-center px-4 py-12 sm:px-6 lg:px-12">
        <div className="grid gap-10 rounded-[28px] border border-slate-200 bg-white p-8 shadow-sm md:grid-cols-[1.1fr_1fr] md:p-12">
          <section className="flex flex-col justify-between gap-12">
            <div className="space-y-4 flex flex-col justify-center h-full">
              <div className="flex items-center gap-3">
                {/* <span className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-900 text-sm font-semibold text-white">Q</span> */}
                <div>
                  <p className="text-xs font-medium uppercase tracking-[0.3em] text-slate-400">Querco</p>
                </div>
              </div>
              <h1 className="text-2xl font-semibold text-primary-500">Accedez a votre espace</h1>
            </div>
            <div className="flex flex-wrap items-center gap-3 text-xs text-slate-400">
              <span>&copy; {new Date().getFullYear()} Querco</span>
              <span className="hidden h-3 w-px bg-slate-200 sm:inline" />
              <span>Support: support@querco.co</span>
            </div>
          </section>

          <section className="border-t border-slate-100 pt-8 md:border-t-0 md:pt-0 md:pl-8">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="space-y-2">
                <label className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500" htmlFor="identifier">
                  Identifiant
                </label>
                <input
                  id="identifier"
                  className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-slate-900 focus:ring-2 focus:ring-slate-900/10"
                  type="text"
                  value={user.email}
                  autoComplete="username"
                  placeholder="Email ou identifiant"
                  onChange={(e) => setUser({ ...user, email: e.target.value })}
                />
                <p className="text-xs text-slate-400">Votre adresse e-mail, ou l’identifiant remis par votre laboratoire (ex. accueil@labo).</p>
              </div>

              <div className="space-y-2">
                <label className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500" htmlFor="password">
                  Mot de passe
                </label>
                <input
                  id="password"
                  className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-slate-900 focus:ring-2 focus:ring-slate-900/10"
                  type="password"
                  value={user.password}
                  autoComplete="current-password"
                  placeholder="Mot de passe"
                  onChange={(e) => setUser({ ...user, password: e.target.value })}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="flex w-full items-center justify-center gap-2 rounded-xl bg-primary-500 px-4 py-3 text-sm font-semibold text-white transition hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-white disabled:cursor-not-allowed disabled:bg-slate-300"
              >
                {isSubmitting ? (
                  <svg className="h-5 w-5 animate-spin text-white" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
                  </svg>
                ) : (
                  <span>Se connecter</span>
                )}
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Auth;
